// extracted by mini-css-extract-plugin
export default {"container":"CardsContainer_container__b7aVE","page":"CardsContainer_page__HHiLg","btn":"CardsContainer_btn__1C7Sj","btn2":"CardsContainer_btn2__l4w6B"};